<script lang="ts">
export default {
  name: "Loader",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <div class="loader-overlay" :class="{ visible: visible }">
    <div>
      <span
        ><v-progress-circular
          :size="70"
          :width="8"
          color="#E05C91"
          bg-color="#fff"
          indeterminate
        ></v-progress-circular
      ></span>
    </div>
  </div>
</template>

<style lang="scss">
.loader-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(231, 193, 211, 0.5);
  z-index: 1005;
  text-align: center;
  backdrop-filter: blur(2px);

  &.visible {
    display: initial;
  }

  div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  span {
    display: inline-block;
    position: absolute;
    top: calc(50% - 35px);
    left: calc(50% - 35px);
  }
}
</style>
